import { motion } from "framer-motion";

export const scrollToSection = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  // #schedule tucks the strip's bottom border line under the fixed header so no stray line shows;
  // -60 tucks each section's own top hairline just behind the header so no lining shows on landing
  const offset = hash === "#schedule" ? -40 : -60;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ num, label, light = false }) => (
  <div className="flex items-center gap-3" data-testid={`chapter-${num}`}>
    <span className="h-2.5 w-2.5 shrink-0 bg-safety" />
    <span
      className={`font-mono text-xs font-bold uppercase tracking-[0.3em] ${
        light ? "text-white/70" : "text-slate-500"
      }`}
    >
      [ {num} ] — {label}
    </span>
  </div>
);
